import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { FadeIn, FadeOut } from '@shared/animations';
import { Store } from '@ngxs/store';
import { PublicPortalState } from '@shared/states/public-portal/public-portal.state';
import { Observable, Subject } from 'rxjs';
import { PublicPortalStateModel, Logo } from '@shared/types';
import { FeaturesService } from '@shared/services/features/features.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'portal-blocker',
  templateUrl: './blocker.component.html',
  styleUrls: ['./blocker.component.scss'],
  animations: [
    trigger('fadeOnLoad', [
      transition('hidden => visible', [
        useAnimation(FadeIn, { params: { time: '0.15s' } })
      ]),
      transition(':leave', [
        useAnimation(FadeOut, { params: { time: '0.15s' } })
      ])
    ])
  ]
})
export class BlockerComponent implements OnInit {
  publicPortal$ = this.store.select<PublicPortalStateModel>(PublicPortalState);
  apogee: string;
  unsubscribe$ = new Subject();
  logo: Logo;
  constructor(private featuresService: FeaturesService, private store:Store) {
    this.subscriptions();
  }

  ngOnInit() {
    this.apogee = this.featuresService.getCompany();
  }

  subscriptions(): void {
    this.publicPortal$.pipe(takeUntil(this.unsubscribe$)).subscribe(portal => {
      const { logo } = portal;
      this.logo = logo;
    });
  }
}
